import { ROVVideoStatus } from 'src/enums'
import { IBaseEntity } from './base-entity'

export interface IROVVideosWithSharedCategories {
  sharedCategories: IROVVideoCategory[]
  videos: IROVVideoMinimal[]
}

export interface IROVVideo {
  title: string
  vimeoId: string
  azureBlobURL?: string
  azureThumbnailURL?: string
  category?: IROVVideoCategory
  thumbnail_URL?: string
  status?: ROVVideoStatus
}

export interface IROVVideoMinimal extends IROVVideo, IBaseEntity {
  description?: string
  createdAt: Date
}

export interface IROVVideoUpdate {
  id: number
  category: IROVVideoCategoryWithoutShare
}

export interface IROVVideoCreate extends IROVVideoWithoutShare {
  description?: string
  mooringId: EntityId
  positionId: EntityId
  mainComponentId: EntityId
  isShared: boolean
  status?: ROVVideoStatus
  azureBlobURL?: string
  azureThumbnailURL?: string
  contentLength?: number
}

export interface IROVVideoCategory extends IROVVideoCategoryWithoutShare {
  isShared: boolean
}

export interface IROVVideoWithoutShare {
  title: string
  vimeoId?: string
  category?: IROVVideoCategoryWithoutShare
}

export interface IInitializeAzureBlobUploadDto {
  fileSize: number
  fileName?: string
  screenshotFileName?: string
  title?: string
  description?: string
}

export interface IAzureBlobUploadInitDto {
  uploadUrl: string
  blobUrl: string
  blobName: string
  screenshotUploadUrl?: string
  screenshotBlobUrl?: string
  screenshotBlobName?: string
}

export interface IROVVideoUploadProviderDto {
  useAzureBlob: boolean
}

export interface IInitializeROVVideoDto {
  fileSize: number
  title?: string
  description?: string
}

export interface IROVVideoCategoryWithoutShare {
  id: EntityId
  categoryName: string
}

export interface IROVVideoCategoryUpdate {
  categoryName: string
  isShared: boolean
}
export interface ISyncBatchRequest {
  batchSize: number
}

export interface IPendingCountDto {
  pendingCount: number
}

export interface ISyncVideoResult {
  videoId: number
  vimeoId: string
  title: string
  outcome: string
  detail: string | null
}

export interface ISyncProgressDto {
  status: string
  total: number
  processed: number
  failed: number
  updated: number
  skipped: number
  startedAt?: string
  completedAt?: string
  message?: string
  recentResults?: ISyncVideoResult[]
  errors?: ISyncVideoResult[]
  estimatedSeconds?: number
  remainingSeconds?: number
}

// Where a ROV video is attached. Matches Core.Enums.ROVVideoTargetType.
export enum ROVVideoTargetType {
  Position = 0,
  MainComponent = 1,
}

export interface IROVVideoMove {
  targetType: ROVVideoTargetType
  targetId: number
}
